import React from 'react';
import { classNames } from '../../utils/classNames';
import { Tooltip } from './Tooltip';

export const Tabs = ({
  tabs,
  value,
  onChange,
  className,
  tabClassName,
  activeTabClassName,
  inactiveTabClassName
}) => (
  <div
    className={classNames(
      'inline-flex max-w-full items-center justify-center rounded-2xl border border-border bg-white/60 p-1 dark:bg-slate-950/30',
      className
    )}
  >
    {tabs.map((tab) => {
      const tabButton = (
        <button
          key={tab.value}
          type="button"
          onClick={() => onChange(tab.value)}
          aria-label={tab.title || tab.label || undefined}
          className={classNames(
            'inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-2xl px-4 py-2 text-sm font-semibold transition',
            tab.label ? 'min-w-[120px]' : 'h-8 w-8 px-0 py-0',
            !tab.label && 'gap-0',
            tabClassName,
            value === tab.value
              ? classNames('bg-accent text-white shadow-sm dark:text-slate-950', activeTabClassName)
              : classNames('text-muted hover:text-text', inactiveTabClassName)
          )}
        >
          {tab.icon ? <span className="inline-flex items-center justify-center">{tab.icon}</span> : null}
          {tab.label}
        </button>
      );

      return (
        <Tooltip key={tab.value} content={tab.title || tab.label} className={tab.label ? 'flex-1' : undefined} position="bottom">
          {tabButton}
        </Tooltip>
      );
    })}
  </div>
);
